import * as z from "zod/v4";

export const getWorkOrderBomSkus = {
  name: "getWorkOrderBomSkus" as const,
  input: z.object({ kind: z.enum(["input", "output"]) }),
  output: z.object({ skus: z.array(z.string()) }),
};
